import type { Scheduler, ViewPresetConfig } from '@bryntum/scheduler';

export interface SchedulerView {
  viewPreset: ViewPresetConfig;
  startDate: Date;
  endDate: Date;
}

export function applySchedulerView(
  scheduler: Pick<Scheduler, 'viewPreset' | 'setTimeSpan'>,
  previous: SchedulerView | null,
  next: SchedulerView,
): boolean {
  const { viewPreset, startDate, endDate } = next;
  if (!Number.isFinite(startDate.getTime()) || !Number.isFinite(endDate.getTime()) || startDate >= endDate) {
    return false;
  }

  if (previous?.viewPreset !== viewPreset) {
    scheduler.viewPreset = {
      ...viewPreset,
      options: { startDate, endDate },
    };
    return true;
  }

  if (previous.startDate.getTime() !== startDate.getTime() || previous.endDate.getTime() !== endDate.getTime()) {
    scheduler.setTimeSpan(startDate, endDate);
    return true;
  }

  return false;
}
